import { useMutation, useQueryClient } from 'react-query';
import { partnerWorkerService } from 'partner/shared/services';
import { QUERY_KEYS } from 'api/query-keys';
import { PartnerWorkerFormValues } from '../partner-worker-form.types';

type UpdatePartnerWorkerParams = {
  partnerWorkerId: string;
  payload: PartnerWorkerFormValues;
};

export const useUpdatePartnerWorker = () => {
  const mutationFn = async ({ partnerWorkerId, payload }: UpdatePartnerWorkerParams) => {
    await partnerWorkerService.updatePartnerWorker(partnerWorkerId, {
      firstName: payload.firstName,
      infix: payload.infix,
      lastName: payload.lastName,
      email: payload.email,
      phone: payload.phone,
      accreditations: payload.accreditations,
      employmentType: payload.employmentType,
      employmentId: payload.employmentId ? payload.employmentId : undefined,
      salaryScale: payload.salaryScale ?? undefined,
      salaryStep: payload.salaryStep ?? undefined,
      contractHours: payload.contractHours ?? undefined,
      startDate: payload.startDate ? new Date(payload.startDate).toISOString() : undefined,
      endDate: payload.endDate ? new Date(payload.endDate).toISOString() : undefined,
    });
  };
  const queryClient = useQueryClient();

  return useMutation(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.partners());
      queryClient.invalidateQueries(QUERY_KEYS.checkouts());
    },
  });
};
